(() => {
  const componentSelector = 'slider-component.thumbnail-slider--vertical';
  const controllerKey = 'productThumbnailLeftController';

  class ProductThumbnailLeftController {
    constructor(component) {
      this.component = component;
      this.slider = component.querySelector('[id^="Slider-Thumbnails-"]');
      this.previousButton = component.querySelector('button[name="previous"]');
      this.nextButton = component.querySelector('button[name="next"]');
      this.scrollEndTimer = null;

      if (!this.slider || !this.previousButton || !this.nextButton) return;

      this.onClick = this.onClick.bind(this);
      this.updateButtons = this.updateButtons.bind(this);
      this.component.addEventListener('click', this.onClick, true);
      this.slider.addEventListener('scroll', this.updateButtons, { passive: true });

      this.resizeObserver = new ResizeObserver(this.updateButtons);
      this.resizeObserver.observe(this.slider);
      this.updateButtons();
    }

    get items() {
      return Array.from(this.slider.querySelectorAll('.thumbnail-list__item')).filter(
        (item) => item.getClientRects().length > 0
      );
    }

    getPosition(item) {
      const sliderRect = this.slider.getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();
      return itemRect.top - sliderRect.top + this.slider.scrollTop;
    }

    updateButtons() {
      const maxScroll = Math.max(0, this.slider.scrollHeight - this.slider.clientHeight);
      this.previousButton.disabled = this.slider.scrollTop <= 1;
      this.nextButton.disabled = this.slider.scrollTop >= maxScroll - 1;
    }

    onClick(event) {
      const button = event.target.closest('button[name="previous"], button[name="next"]');
      if (!button || !this.component.contains(button)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const items = this.items;
      if (items.length < 2) return;

      const positions = items.map((item) => this.getPosition(item));
      const direction = button.name === 'next' ? 1 : -1;
      const step = Math.max(1, Number(button.dataset.step) || 1);
      const currentPosition = this.slider.scrollTop;
      let currentIndex = 0;

      positions.forEach((position, index) => {
        if (position <= currentPosition + 1) currentIndex = index;
      });

      const targetIndex = Math.min(items.length - 1, Math.max(0, currentIndex + direction * step));
      const maxScroll = Math.max(0, this.slider.scrollHeight - this.slider.clientHeight);
      const targetPosition = Math.min(maxScroll, Math.max(0, positions[targetIndex]));

      this.slider.scrollTo({ top: targetPosition, behavior: 'smooth' });
      window.clearTimeout(this.scrollEndTimer);
      this.scrollEndTimer = window.setTimeout(this.updateButtons, 350);
    }

    destroy() {
      window.clearTimeout(this.scrollEndTimer);
      this.component.removeEventListener('click', this.onClick, true);
      this.slider?.removeEventListener('scroll', this.updateButtons);
      this.resizeObserver?.disconnect();
      delete this.component[controllerKey];
    }
  }

  const initialize = (container = document) => {
    const components = [];

    if (container.matches?.(componentSelector)) components.push(container);
    container.querySelectorAll?.(componentSelector).forEach((component) => components.push(component));

    components.forEach((component) => {
      if (!component[controllerKey]) {
        component[controllerKey] = new ProductThumbnailLeftController(component);
      }
    });
  };

  if (!window.productThumbnailLeftGallery) {
    window.productThumbnailLeftGallery = { initialize };

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll?.(componentSelector).forEach((component) => {
        component[controllerKey]?.destroy();
      });
    });
  }

  window.productThumbnailLeftGallery.initialize(document);
})();
